/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgDropoffLocation32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M7 3.25a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5zM5.75 6a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M7.52 14.562v-.001l.004-.003.013-.011.045-.042c.04-.035.096-.087.168-.153a26.264 26.264 0 002.365-2.522c.646-.792 1.307-1.711 1.81-2.67.498-.95.87-1.996.87-3.026 0-3.346-2.578-5.884-5.772-5.884C3.829.25 1.25 2.788 1.25 6.134c0 1.03.373 2.076.87 3.026.503.959 1.164 1.878 1.81 2.67a26.272 26.272 0 002.533 2.675l.046.041.012.012.004.003.001.001c.284.25.71.25.994 0zM2.75 6.134c0-2.53 1.919-4.384 4.273-4.384 2.354 0 4.273 1.855 4.273 4.384 0 .687-.256 1.483-.7 2.33-.439.838-1.034 1.67-1.643 2.416a24.78 24.78 0 01-1.93 2.093l-.256-.25a24.78 24.78 0 01-1.675-1.843c-.609-.746-1.204-1.578-1.643-2.416-.444-.847-.699-1.643-.699-2.33zm3.776 8.428L7.023 14l-.497.562zm.994 0L7.023 14l.497.562z'
      />
      <path
        fill='currentColor'
        d='M16.516 7.775A5.324 5.324 0 0016 7.75a.75.75 0 010-1.5c.223 0 .443.01.661.032l.746.073-.145 1.493-.746-.073zM19.33 8.941l-.58-.476.953-1.159.58.476c.34.28.654.594.935.935l.476.58-1.16.952-.475-.58a5.289 5.289 0 00-.729-.728zM21.225 12.484l-.073-.746 1.493-.146.073.747c.021.218.032.438.032.661v1.25h-1.5V13c0-.174-.009-.346-.025-.516zM21.25 17v-1.25h1.5V17a.75.75 0 01-1.5 0zM21.866 23.436l2.933 2.94 1.062-1.06-2.936-2.941 2.936-2.942-1.062-1.06-2.933 2.94-2.934-2.94-1.061 1.06 2.935 2.942-2.935 2.941 1.062 1.06 2.933-2.94z'
      />
      <path
        fill='currentColor'
        d='M14.461 2.75H29.25v26.5H2.75V14h-1.5v16c0 .414.336.75.75.75h28a.75.75 0 00.75-.75V2a.75.75 0 00-.75-.75H14.461v1.5z'
      />
    </svg>
  );
}

export default SvgDropoffLocation32;
